export const STATIC_REVIEWS = [
    {
        name: 'Mehul & Ritu Joshi',
        meta: 'Bali, 2024',
        avatar: 'MR',
        color: '#3e7e6a',
        stars: 5,
        text: '"Rajesh bhai and the team made our honeymoon absolutely magical. Every detail was perfect — from the villa to the surprise candle-light dinner. Will only travel with Silver Sky from now on."',
    },
    {
        name: 'Sharma Family',
        meta: 'Switzerland, 2023',
        avatar: 'SF',
        color: '#2563eb',
        stars: 5,
        text: '"Our family of 6 including elderly parents had the smoothest trip to Europe ever. Wheelchair access arrangements, special meals — everything was taken care of proactively. Outstanding!"',
    },
    {
        name: 'Darshna Patel',
        meta: 'Dubai, 2024',
        avatar: 'DP',
        color: '#d4a437',
        stars: 5,
        text: '"The visa was processed in 3 days, the hotel was stunning, and the desert safari was beyond expectations. I felt genuinely taken care of — not just another booking number."',
    },
    {
        name: 'Karan & Pooja Shah',
        meta: 'Maldives, 2025',
        avatar: 'KP',
        color: '#7c3aed',
        stars: 5,
        text: '"We were celebrating our anniversary and Silver Sky turned it into a dream vacation. The overwater bungalow, the surprise cake — pure perfection. Highly recommended!"',
    },
    {
        name: 'Vikram Nair',
        meta: 'New York, 2025',
        avatar: 'VN',
        color: '#0891b2',
        stars: 5,
        text: '"Corporate travel sorted! Got business class tickets at half the price I usually pay. Their team negotiated directly with the airline. Truly professional service."',
    },
    {
        name: 'Ananya Gupta',
        meta: 'Thailand, 2024',
        avatar: 'AG',
        color: '#be185d',
        stars: 5,
        text: '"Solo trip to Thailand — everything was seamless. Airport pick-up, hotel check-in, day tours — all pre-arranged. I just showed up and enjoyed. Best travel experience ever!"',
    },
    {
        name: 'Rohan & Sneha Iyer',
        meta: 'Europe, 2023',
        avatar: 'RS',
        color: '#b45309',
        stars: 5,
        text: '"7 countries in 14 days with zero stress! The itinerary was perfectly paced. Every hotel was centrally located and all the guides spoke Hindi. Silver Sky is unbeatable."',
    },
    {
        name: 'Priya Mehta',
        meta: 'Singapore, 2024',
        avatar: 'PM',
        color: '#059669',
        stars: 5,
        text: '"Planned a trip for my parents\' 35th anniversary. Silver Sky handled everything — right down to the cake at the hotel. My parents couldn\'t stop talking about how perfect it was."',
    },
    {
        name: 'Amit Desai',
        meta: 'Japan, 2025',
        avatar: 'AD',
        color: '#dc2626',
        stars: 5,
        text: '"Japan during cherry blossom season was already magical, but having an itinerary crafted by Silver Sky made it extraordinary. Every restaurant, every ryokan — curated to perfection."',
    },
    {
        name: 'Kavita & Suresh Rao',
        meta: 'Kerala, 2024',
        avatar: 'KR',
        color: '#0f766e',
        stars: 5,
        text: '"The houseboat experience in Kerala was beyond what we imagined. Local authentic food, beautiful backwaters, complete privacy. Why did we ever book anywhere else?"',
    },
];
